import { FC } from "react";
import { Button, Popup, StrictButtonProps } from "semantic-ui-react";

interface IPopupButtonProps extends StrictButtonProps {
  onClick?: () => {};

  popupContent: string;
  to?: string;
}

const PopupButton: FC<IPopupButtonProps> = ({
  onClick,
  popupContent,
  color,
  children,
  ...props
}) => (
  <Popup
    trigger={
      <Button onClick={onClick} size="mini" color={color} {...props}>
        {children}
      </Button>
    }
    content={popupContent}
    flowing
  />
);

export default PopupButton;
